export default __webpack_public_path__ + "static/accordianTabsBg-bef0f83247da195367546555c24db934.png";